import { authHeader } from '@/_helpers'

const apiUrl = process.env.VUE_APP_ROOT_API

export const teamsOverviewApi = {
  getOverview,
  postponeDeletion,
}

function getOverview(params = {}) {
  const query = new URLSearchParams()
  if (params.tab) query.set('tab', params.tab)
  if (params.condition) query.set('condition', params.condition)
  if (params.am_id) query.set('am_id', params.am_id)
  if (params.q) query.set('q', params.q)
  if (params.page) query.set('page', params.page)
  if (params.size) query.set('size', params.size)

  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  const queryString = query.toString()
  const url = `${apiUrl}/admin/teams-overview${queryString ? `?${queryString}` : ''}`
  return fetch(url, requestOptions).then(handleResponse)
}

function postponeDeletion({ team_ids, days }) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ team_ids, days }),
  }
  return fetch(`${apiUrl}/admin/teams/postpone`, requestOptions).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = data || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
